// extracted by mini-css-extract-plugin
module.exports = {"blocks":"blocks-module--blocks--1_B-D","insetFirst":"blocks-module--insetFirst--2ANQH"};